<template>
  <el-button class="reactivate-button" type="success" plain>
    <slot />
  </el-button>
</template>

<style scoped>
/* Element's success palette, re-based on emerald-500 (same hue as the active-row checkboxes) */
.reactivate-button {
  --el-color-success: #10b981;
  --el-color-success-light-3: #58cea7;
  --el-color-success-light-5: #88dcc0;
  --el-color-success-light-7: #b7ead9;
  --el-color-success-light-8: #cff1e6;
  --el-color-success-light-9: #e7f8f2;
  --el-color-success-dark-2: #0d9467;
}
</style>
